import React from "react";
import { Link } from "react-router-dom";
import ClientShell from "@/components/ClientShell";
import {
  ArrowLeft,
  EnvelopeSimple,
  Phone,
  ChatCircleText,
  MapPin,
  NavigationArrow,
  Storefront,
} from "@phosphor-icons/react";

const SUPPORT_EMAIL = "Divyanshu.fdr@stonlink.com";
const SUPPORT_PHONE_DISPLAY = "+971 50 735 8704";
const SUPPORT_PHONE_TEL = "+971507358704";
const SHOWROOM_ADDRESS = "Ibn Battuta office building, Dubai, UAE";
const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  SHOWROOM_ADDRESS
)}`;

export default function Help() {
  return (
    <ClientShell>
      <Link
        to="/more"
        data-testid="help-back"
        className="inline-flex items-center gap-2 mt-tiny text-zinc-500 hover:text-zinc-900 mb-6"
      >
        <ArrowLeft size={14} /> Back to More
      </Link>

      <div className="mb-8 flex items-center gap-4">
        <div className="w-14 h-14 bg-[#FF5A1F]/10 text-[#FF5A1F] grid place-items-center">
          <ChatCircleText size={28} weight="duotone" />
        </div>
        <div>
          <div className="mt-tiny text-[#FF5A1F]">Support</div>
          <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight text-zinc-900 mt-1">
            Help &amp; support
          </h1>
          <p className="mt-1 text-sm text-zinc-600">We're here — reach out any time.</p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2 max-w-3xl">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid="help-email"
          className="bg-white border border-zinc-200 hover:border-zinc-900 p-6 flex items-start gap-4 transition-all hover:-translate-y-0.5"
        >
          <div className="w-12 h-12 bg-[#0047AB]/10 text-[#0047AB] grid place-items-center shrink-0">
            <EnvelopeSimple size={22} weight="duotone" />
          </div>
          <div className="min-w-0">
            <div className="font-display font-bold text-zinc-900">Email support</div>
            <div className="mt-1 text-sm text-zinc-600 break-all" data-testid="help-email-value">
              {SUPPORT_EMAIL}
            </div>
            <div className="mt-2 mt-tiny text-zinc-400">Typical reply within 4 business hours</div>
          </div>
        </a>

        <div className="bg-white border border-zinc-200 p-6 flex flex-col justify-between gap-4">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-[#FF5A1F]/10 text-[#FF5A1F] grid place-items-center shrink-0">
              <Phone size={22} weight="duotone" />
            </div>
            <div className="min-w-0">
              <div className="font-display font-bold text-zinc-900">Call us</div>
              <div className="mt-1 text-sm text-zinc-600" data-testid="help-phone-value">
                {SUPPORT_PHONE_DISPLAY}
              </div>
              <div className="mt-2 mt-tiny text-zinc-400">Sun–Fri · 9 AM – 7 PM GST</div>
            </div>
          </div>
          <a
            href={`tel:${SUPPORT_PHONE_TEL}`}
            data-testid="help-call-button"
            className="inline-flex items-center justify-center gap-2 bg-[#FF5A1F] hover:bg-[#E04814] text-white px-5 py-3 font-medium transition-colors"
          >
            <Phone size={18} weight="fill" /> Call support
          </a>
        </div>
      </div>

      {/* Showroom */}
      <div
        className="mt-8 bg-white border border-zinc-200 p-6 md:p-8 max-w-3xl"
        data-testid="help-showroom"
      >
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-zinc-900 text-white grid place-items-center shrink-0">
            <Storefront size={22} weight="duotone" />
          </div>
          <div className="min-w-0">
            <div className="mt-tiny text-zinc-500">Visit our showroom</div>
            <div className="font-display font-bold text-xl md:text-2xl text-zinc-900 mt-1">
              Ston Link Dubai showroom
            </div>
            <div
              className="mt-2 flex items-start gap-2 text-sm text-zinc-700"
              data-testid="help-address-value"
            >
              <MapPin size={18} className="text-[#FF5A1F] shrink-0 mt-0.5" weight="duotone" />
              <span>{SHOWROOM_ADDRESS}</span>
            </div>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="help-maps-button"
              className="mt-5 inline-flex items-center gap-2 bg-zinc-900 hover:bg-zinc-800 text-white px-5 py-3 font-medium transition-colors"
            >
              <NavigationArrow size={18} weight="fill" /> Open in Google Maps
            </a>
          </div>
        </div>
      </div>

      <div className="mt-8 bg-white border border-zinc-200 p-6 md:p-8 max-w-3xl">
        <div className="mt-tiny text-zinc-500 mb-3">Common questions</div>
        <ul className="space-y-3 text-sm text-zinc-700">
          <li>
            <b className="text-zinc-900">How do I request a quote?</b>
            <br />
            Tap Home → choose a category → "Request a quote" — or use the Quotations tab and hit "New request".
          </li>
          <li>
            <b className="text-zinc-900">Where are my certificates?</b>
            <br />
            More → Certificates. All quality and test certificates for your orders are listed there.
          </li>
          <li>
            <b className="text-zinc-900">I forgot my password.</b>
            <br />
            Message your Ston Link account manager — we'll reset it and send you new credentials.
          </li>
        </ul>
      </div>
    </ClientShell>
  );
}
